import React from "react";
import { connect } from "react-redux";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import SparkasseIcon from "assets/images/svg/sparkasse-icon.svg";
import { disconnectSparkasseAccount } from "store/user/account/actions";

const messages = {
    areYouSureDisconnectSparkasse: "are_you_sure_disconnect_sparkasse",
    disconnectingYourSparkasseAccount: "disconnecting_your_sparkasse_account",
    youCanRelink: "you_can_relink",
    yesDisconnect: "yes_disconnect",
    cancel: "form_cancel",
};

const Confirmation = ({ backSlideEffect, setBackSlideEffect, open, setStep, resetToInitial, disconnectSparkasseAccount }) => {
    useSideModalScrollToTop();
    const { formatMessage } = useFormattedMessage();

    const handleDisconnect = () => {
        disconnectSparkasseAccount();
        resetToInitial();
    };

    const handleCancel = () => {
        setBackSlideEffect("step-slide-right");
        setStep("accountDetails");
    };

    return (
        <div className={`link-sparkasse-confirmation-screen p-6 ${backSlideEffect}`}>
            <SparkasseIcon />
            <h4 className="mt-8 mb-4">{formatMessage(messages.areYouSureDisconnectSparkasse)}</h4>
            <p className="mb-0">{formatMessage(messages.disconnectingYourSparkasseAccount)}</p>
            <p>{formatMessage(messages.youCanRelink)}</p>

            {open && (
                <div className="bottom-bar-container px-6 d-block">
                    <button className="mw-100 danger mb-4" onClick={handleDisconnect}>
                        {formatMessage(messages.yesDisconnect)}
                    </button>
                    <button className="mw-100 tertiary" onClick={handleCancel}>
                        {formatMessage(messages.cancel)}
                    </button>
                </div>
            )}
        </div>
    );
};

const mapDispatchToProps = {
    disconnectSparkasseAccount,
};

export default connect(null, mapDispatchToProps)(Confirmation);
